module.exports = __webpack_public_path__ + "927a392a85980c01edf95c363198ecae.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/transfer-unread.svg
// module id = 124
// module chunks = 0